import { Checkbox, CheckboxProps, FormControlLabel, Typography } from "@mui/material";
import { sxFormError } from "../../assets/styles/sxProps";
import styles from './styles.module.css';
import { sxCheckbox } from "./sxProps";

interface Props extends CheckboxProps {
  ariaLabel?: string;
  label: string;
  error?: boolean;
  errorMessage?: string;
}

const FormControlCheckbox: React.FC<Props> = ({ error, errorMessage, ariaLabel, label, ...checkboxProps }) => {


  return (
    <div className={styles['checkbox-form-control-container']}>
      <FormControlLabel control={
        <Checkbox
          tabIndex={0}
          sx={{ color: 'var(--primary-blue)' ,'&.Mui-checked': { color: 'var(--primary-blue)' } }}
          indeterminate={false}
          onChange={checkboxProps.onChange}
          inputProps={{
            'aria-label': ariaLabel || 'Checkbox',
          }}
          {...checkboxProps}
        />
      } label={label} sx={sxCheckbox} />
      {!!error && <Typography sx={sxFormError}>{errorMessage}</Typography>}
    </div>
  )
}

export { FormControlCheckbox };

